/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(function ($) {
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery(".accordion p:empty, .orbit p:empty").remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(
		function () {
			if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
				jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
			} else {
				jQuery(this).wrap("<div class='responsive-embed'/>");
			}
		}
	);

	var selected_lunch_day = "ma";
	$(".lunchdayitem").on("click", function () {
		var $this = $(this);
		var $day = $this.attr("day");

		$(".lunchdayitem")
			.addClass("lunchdayitemactive")
			.not('[day="' + $day + '"]')
			.removeClass("lunchdayitemactive");
		$(".lunchitem").finish();
		$(".lunchitem")
			.fadeIn()
			.not('[day="' + $day + '"]')
			.hide();

		lunchGridLayout();

        allSmall();
	});

	function lunchGridLayout() {
		var items = $(".lunchitem:visible");
		// $(".lunchmeals", items).matchHeight();
	}

	var lunches_open = false;
	$("#lunches_show").on("click", function (e) {
		if (lunches_open) {
			$(".cell--lounas").slice(6).addClass("hide");
            $("#lunches_show").removeClass("less");
			//$("#lunches_show").text("Näytä lisää");
            allSmall();
		} else {
			$(".cell--lounas").removeClass("hide");
            $("#lunches_show").addClass("less");
			//$("#lunches_show").text("Näytä vähemmän");
            checkHeights();
		}
		lunches_open = !lunches_open;
		lunchGridLayout();
	});

	var lunches_open_2 = false;
	$("#lunches_show_2").on("click", function (e) {
		if (lunches_open_2) {
			$(".cell--lounas--2").slice(6).addClass("hide");
            $("#lunches_show_2").removeClass("less");
			//$("#lunches_show_2").text("Näytä lisää");
            allSmall();
		} else {
			$(".cell--lounas--2").removeClass("hide");
            $("#lunches_show_2").addClass("less");
			//$("#lunches_show_2").text("Näytä vähemmän");
            checkHeights();
		}
		lunches_open_2 = !lunches_open_2;
		lunchGridLayout();
	});

	lunchGridLayout();

	$(".lunchdayitemactive").trigger("click");
});

jQuery("#main-nav").on("show.zf.dropdownmenu", function () {
	var dropdown = jQuery(this).find(".is-dropdown-submenu");
	dropdown.css("display", "none");
	dropdown.fadeIn();
});

jQuery("#main-nav").on("hide.zf.dropdownmenu", function () {
	var dropdown = jQuery(this).find(".is-dropdown-submenu");
	dropdown.css("display", "inherit");
	dropdown.fadeOut();
});




    const lunchCells = document.querySelectorAll('.lunchcell');
    
    // Set a threshold based on the screen width
    var elementsMaxHeight = maxHeights();


    lunchCells.forEach(function (lunchCell) {
        const lunchElement = lunchCell.querySelector('.lunch-element');
        const showMoreButton = lunchCell.querySelector('.showMoreButton');

        if (lunchElement.scrollHeight > lunchElement.clientHeight) {
            showMoreButton.style.display = 'block';
        } else {
            if (lunchCell.classList.contains('hide')) {
            } else {
                lunchCell.classList.add('alwaysopen');
            }
        }

        showMoreButton.addEventListener('click', function () {
            lunchCell.classList.toggle('open');

            if (lunchElement.style.maxHeight === elementsMaxHeight || lunchElement.style.maxHeight === "") {
                lunchElement.style.maxHeight = "none";
            } else {
                lunchElement.style.maxHeight = elementsMaxHeight;
            }
        });
    });


    function checkHeights() {

        lunchCells.forEach(function (lunchCell) {
            const lunchElement = lunchCell.querySelector('.lunch-element');
            const showMoreButton = lunchCell.querySelector('.showMoreButton');
    
            if (lunchElement.scrollHeight > lunchElement.clientHeight) {
                showMoreButton.style.display = 'block';
            } else {
                if (lunchCell.classList.contains('hide')) {
                } else {
                    lunchCell.classList.add('alwaysopen');
                }
            }
        });
    }

    function allSmall() {
        lunchCells.forEach(function (lunchCell) {
            const lunchElement = lunchCell.querySelector('.lunch-element');
            const showMoreButton = lunchCell.querySelector('.showMoreButton');
            if (lunchCell.classList.contains('open')) {
                lunchCell.classList.remove('open');
            }
            if (lunchCell.classList.contains('alwaysopen')) {
                lunchCell.classList.remove('alwaysopen');
            }
            lunchElement.style.maxHeight = elementsMaxHeight;
            showMoreButton.style.display = 'none';

            checkHeights();

        });
    }

    function maxHeights() {
        if (window.innerWidth < 640) {
            return "200px";
        } else if (window.innerWidth < 1024) {
            return "300px";
        } else {
            return "300px";
        }
    }




//single lunch
const singleLunchCells = document.querySelectorAll('.wp-block-lunch-single .week-lunch');
    
// Set a threshold based on the screen width
//var elementsMaxHeight = maxHeights();




singleLunchCells.forEach(function (singleLunchCell) {
    const lunchElement = singleLunchCell.querySelector('.week-lunch-element');
    const showMoreButton = singleLunchCell.querySelector('.singleshowMoreButton');

    if (lunchElement.scrollHeight > lunchElement.clientHeight) {
        showMoreButton.style.display = 'block';
    } else {
        if (singleLunchCell.classList.contains('hide')) {
        } else {
            singleLunchCell.classList.add('alwaysopen');
        }
    }

    showMoreButton.addEventListener('click', function () {
        singleLunchCell.classList.toggle('singleopen');

        if (lunchElement.style.maxHeight === elementsMaxHeight || lunchElement.style.maxHeight === "") {
            lunchElement.style.maxHeight = "none";
        } else {
            lunchElement.style.maxHeight = elementsMaxHeight;
        }
    });
});


function singleCheckHeights() {

    singleLunchCells.forEach(function (singleLunchCell) {
        const lunchElement = singleLunchCell.querySelector('.week-lunch-element');
        const showMoreButton = singleLunchCell.querySelector('.singleshowMoreButton');

        if (lunchElement.scrollHeight > lunchElement.clientHeight) {
            showMoreButton.style.display = 'block';
        } else {
            if (singleLunchCell.classList.contains('hide')) {
            } else {
                singleLunchCell.classList.add('alwaysopen');
            }
        }
    });
}

function singleAllSmall() {

    singleLunchCells.forEach(function (singleLunchCell) {
        const lunchElement = singleLunchCell.querySelector('.week-lunch-element');
        const showMoreButton = singleLunchCell.querySelector('.singleshowMoreButton');
        if (singleLunchCell.classList.contains('singleopen')) {
            singleLunchCell.classList.remove('singleopen');
        }
        if (singleLunchCell.classList.contains('alwaysopen')) {
            singleLunchCell.classList.remove('alwaysopen');
        }
        lunchElement.style.maxHeight = elementsMaxHeight;
        showMoreButton.style.display = 'none';

        singleCheckHeights();

    });
}


window.addEventListener('resize', handleResize);
function handleResize() {
    //allSmall();
    //singleAllSmall();
}


    
function openWeek(evt, weekNumber) {
    var i, tablounascontent, tablounaslinks;
    tablounascontent = document.getElementsByClassName("tablounascontent");
    for (i = 0; i < tablounascontent.length; i++) {
        tablounascontent[i].style.display = "none";
    }
    tablounaslinks = document.getElementsByClassName("tablounaslinks");
    for (i = 0; i < tablounaslinks.length; i++) {
        tablounaslinks[i].className = tablounaslinks[i].className.replace(
            " active",
            ""
        );
    }
    document.getElementById(weekNumber).style.display = "block";
    evt.currentTarget.className += " active";
    allSmall();
}
var defaultopen = document.getElementById("defaultOpen");
if (defaultopen) {
    defaultopen.click();
}


function openNextWeek() {


    var currentweek = document.getElementById('current-week-lunch-container');
    var nextweek = document.getElementById('next-week-lunch-container');
    var nextweekbutton = document.getElementById('nextweekbutton');
    var currentweekbutton = document.getElementById('currentweekbutton');

    currentweek.classList.add('closed');

    if (nextweek.classList.contains('closed')) {
        nextweek.classList.remove('closed');
    }
    nextweekbutton.classList.add('closed');
    

    if (currentweekbutton.classList.contains('closed')) {
        currentweekbutton.classList.remove('closed');
    }
    
    singleCheckHeights();
    singleAllSmall();
}

function openCurrentWeek() {


    var currentweek = document.getElementById('current-week-lunch-container');
    var nextweek = document.getElementById('next-week-lunch-container');
    var nextweekbutton = document.getElementById('nextweekbutton');
    var currentweekbutton = document.getElementById('currentweekbutton');

/*     currentweek.classList.add("open");
    nextweekbutton.classList.add("open");
    nextweek.classList.remove("open");
    currentweekbutton.classList.remove("open"); */

    if (currentweek.classList.contains('closed')) {
        currentweek.classList.remove('closed');
    }
    
    nextweek.classList.add('closed');
    
    if (nextweekbutton.classList.contains('closed')) {
        nextweekbutton.classList.remove('closed');
    }

    currentweekbutton.classList.add('closed');
    singleCheckHeights();
    singleAllSmall();
}
openCurrentWeek();